import React from "react";

interface DirectIconProps {
  size?: number;
}

export default function DirectIcon({ size = 28 }: DirectIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="CBasicCheckbox__icon"
    >
      <path
        d="M6.47989 23.0174C6.49771 22.7725 6.39447 22.5343 6.20352 22.3799C3.57158 20.2511 1.91699 17.0744 1.91699 13.518C1.91699 7.14597 7.29764 1.91675 14.0117 1.91675C20.7115 1.91675 26.0927 7.14546 26.0927 13.518C26.0927 19.8894 20.6989 25.1192 13.998 25.1192C12.8842 25.1192 11.8249 24.9769 10.8047 24.7057C10.663 24.668 10.5133 24.6727 10.3741 24.7192L6.31648 26.0764L6.30097 26.0817C6.29858 26.0826 6.29698 26.083 6.29611 26.0832L6.29474 26.0834L6.29453 26.0834C6.29357 26.0832 6.28806 26.0818 6.28046 26.0759C6.27277 26.0698 6.26712 26.0623 6.26398 26.0555C6.26151 26.0501 6.25978 26.0439 6.26054 26.0336L6.26056 26.0332L6.47989 23.0174Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      ></path>
      <path
        d="M11.8418 10.2611C11.9262 10.2733 11.9965 10.2854 12.0809 10.2976C13.333 10.5653 14.6131 11.7089 15.5979 12.3902C16.1465 12.7796 16.6107 12.7431 17.1594 12.3781C18.327 11.5751 19.5368 10.8086 20.7326 10.0178C21.0561 9.79879 21.3938 9.56763 21.7876 9.85962C22.2237 10.1759 21.9565 10.5166 21.7314 10.8329C20.5497 12.4632 19.3821 14.0935 18.1863 15.7117C17.3704 16.831 16.2168 16.9891 14.9789 16.1983C14.1207 15.6387 13.2345 15.1155 12.3904 14.5315C11.8277 14.1422 11.3635 14.1909 10.8289 14.5559C9.64721 15.3588 8.45145 16.1253 7.2557 16.9161C6.93214 17.1351 6.59451 17.3663 6.20062 17.0621C5.80672 16.7701 6.01774 16.4417 6.22875 16.1375C7.45265 14.4585 8.66247 12.7796 9.88636 11.1006C10.2943 10.5288 11.054 10.1881 11.8418 10.2611Z"
        fill="currentColor"
      ></path>
    </svg>
  );
}
